import type {Identified} from 'typings/portaro.be.types';
import type {OfferingStateDto, OfferingStepType} from './types';
import {OfferingStep} from './offering-step';

export class OfferingState implements Identified<string> {
    id: string;
    steps: OfferingStep[];
    getRemainingSteps: () => OfferingStep[];
    getStepOfType: (stepType: OfferingStepType) => OfferingStep;

    constructor(offeringStateDto: OfferingStateDto) {
        this.steps = offeringStateDto.steps.map((backendStep) => new OfferingStep(backendStep, this));
        this.getStepOfType = (stepType: OfferingStepType) => this.steps.filter((step) => step.type === stepType)[0];
        this.getRemainingSteps = () => this.steps.filter((step) => !step.isDone());
    }
}